import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, LayoutGrid } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export const Header = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-obsidian/15 bg-white/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        <Link
          to="/"
          data-testid="logo-link"
          className="font-serif text-2xl font-medium tracking-tighter text-obsidian"
        >
          LUX<span className="text-signal">•</span>DROP
        </Link>

        <nav className="hidden items-center gap-8 text-xs font-semibold uppercase tracking-[0.2em] text-obsidian/70 md:flex">
          <Link to="/" data-testid="nav-shop" className="transition-colors hover:text-signal">
            Shop
          </Link>
          <Link to="/?category=AI Packs" data-testid="nav-aipacks" className="transition-colors hover:text-signal">
            AI Packs
          </Link>
          <Link to="/?category=Bundles" data-testid="nav-bundles" className="transition-colors hover:text-signal">
            Bundles
          </Link>
        </nav>

        <div className="flex items-center gap-4">
          {user && user.role === "admin" && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className="hidden items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-obsidian transition-colors hover:text-signal sm:flex"
            >
              <LayoutGrid className="h-4 w-4" /> Admin
            </Link>
          )}

          {user ? (
            <>
              <Link
                to="/account"
                data-testid="nav-account"
                className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.15em] text-obsidian transition-colors hover:text-signal"
              >
                <User className="h-4 w-4" /> {user.name?.split(" ")[0] || "Account"}
              </Link>
              <button
                onClick={handleLogout}
                data-testid="logout-btn"
                className="text-obsidian/60 transition-colors hover:text-signal"
                title="Log out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login"
              className="text-xs font-semibold uppercase tracking-[0.15em] text-obsidian transition-colors hover:text-signal"
            >
              Sign in
            </Link>
          )}

          <Link
            to="/cart"
            data-testid="nav-cart"
            className="relative flex items-center text-obsidian transition-colors hover:text-signal"
          >
            <ShoppingBag className="h-5 w-5" />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center bg-signal text-[10px] font-bold text-white"
              >
                {count}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};
